import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
Vue.use(axios)

import BootstrapVue from 'bootstrap-vue'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
Vue.use(BootstrapVue)

import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
Vue.use(VueMoment, {
  moment
})

import App from './App.vue'
import Home from './Home.vue'
import Chat from './Chat.vue'
import Podcasts from './Podcasts.vue'
import Releases from './Releases.vue'
import Schedule from './Schedule.vue'

Vue.prototype.$http = axios;


const routes = [
  { path: '/', component: Home },
  { path: '/chat', component: Chat },
  { path: '/podcasts', component: Podcasts },
  { path: '/releases', component: Releases },
  { path: '/schedule', component: Schedule }
];

Vue.use(VueRouter); // This makes all the magic hapen and Vue recognizes the router-view and router-link

const router = new VueRouter({
  mode: 'history',
  routes
});

new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
});


// WEBPACK FOOTER //
// ./src/main.js